module.exports = __webpack_public_path__ + "static/media/chaines-cable.ecbd100b.svg";